export default "__VITE_ASSET__CD5BVRve__"